import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* updateCarrierResponsibleEmailRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carrier-responsible-email/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateCarrierResponsibleEmailActions.success(data));
    notify("success", "E-mail responsável atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
